<template>
    <div id="page">
        <div class="page-content">
            <div class="page-title page-title-small">
                <h2>
                    <button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>
                    درخواست مرخصی
                    <button data-menu="HelpMenu" class="position-static mr-1"><i class="fa fa-question-circle helpIco"></i></button>
                </h2>
                <button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
            </div>
            <div class="card header-card shape-rounded" data-card-height="150">
                <div class="card-overlay bg-highlight opacity-95"></div>
                <div class="card-overlay dark-mode-tint"></div>
                <div class="card-bg bg-20"></div>
            </div>
            <span data-menu="menu-language" class="optionMenu"></span>


            <div class="card card-style mb-2" v-for="item in VacationList" :key="item.vacationId">
                <div class="p-3" :id="'Invite-'+item.vacationId">
                    <button data-toggle="collapse" type="button" :data-target="'#collapse-'+item.vacationId" class="no-effect collapsed accordion-btn" aria-expanded="false">
                        <span class="d-flex justify-content-between align-items-center">
                            <span class="d-flex justify-content-between" style="width:90%">
                                <b class="font-15 text-dark"><i class="fa fa-calendar text-warning ml-3"></i> {{item.vacationDate}}</b>
                                <span class="font-14 text-muted"><i class="fa fa-user color-green2-dark ml-3"></i>{{item.personTitle}}</span>
                            </span>
                            <i class="fa fa-angle-up text-muted font-18 accordion-icon fa-rotate-180"></i>
                        </span>
                    </button>
                </div>

                <div class="collapse border-t" :id="'collapse-'+item.vacationId" @click.prevent="openDetails(item.vacationId)">
                    <div class="d-flex justify-content-between align-items-center px-4 pt-3">
                        <b><i class="fa fa-check-square color-pink1-dark ml-3"></i> {{item.vacationTypeTitle}}</b>
                        <b><i class="fa fa-check-square color-pink2-dark ml-3"></i> {{item.localTypeTitle}}</b>
                    </div>
                    <div class="d-flex justify-content-between py-3 pr-4 pl-3">
                        <div style="width:90%">

                            <div class="d-flex justify-content-between align-items-center">
                                <b><i class="fa fa-user-shield color-magenta2-light ml-3"></i> {{item.managerUserTitle}}</b>
                                <span class="badge font-10 position-static mt-0 badge-primary">{{item.statusTitle}}</span>
                            </div>
                        </div>
                        <span class="text-left" @click.stop="showMenu(item)" style="width:10%"><i class="fa fa-ellipsis-v font-14"></i></span>
                    </div>
                </div>

            </div>
            <div class="card card-style" v-if="VacationList.length==0 && pageLoading==false">
                <div class="content">
                    <div class="text-center"><i class="fa fa-exclamation-triangle text-warning fa-3x"></i></div>
                    <p class="text-center py-3">هیج موردی یافت نشد.</p>
                </div>
            </div>
        </div>

        <div id="menu-language" class="menu menu-box-bottom menu-box-detached rounded-m" data-menu-effect="menu-over" style="display: block;">
            <div class="m-3">
                <div class="list-group list-custom-small">
                    <router-link :to="{ name: 'VacationEdit', params: { VacationId: vacationId  } }" class="d-flex justify-content-between align-items-center"><span><i class="fa fa-search color-green2-light float-right font-14"></i>مشاهده</span><i class="fa fa-angle-left"></i></router-link>

                    <button @click="SendVacationMessage" class="d-flex justify-content-between align-items-center bg-white p-0"><span class="d-inline-flex align-items-center"><i class="fa fa-check color-magenta2-dark float-right font-14"></i>ارسال برای تایید</span><i class="fa fa-angle-left"></i></button>
                    <button @click="DeleteVacation" class="d-flex justify-content-between align-items-center bg-white p-0"><span class="d-inline-flex align-items-center"><i class="fa fa-trash color-red1-light float-right font-14"></i>حذف</span><i class="fa fa-angle-left"></i></button>

                </div>
                <div class="clear"></div>
            </div>
        </div>
        <transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
            <div v-if="pageLoading" class="w-100 d-flex justify-content-center loadingBox">
                <div class="toast-tiny toast-bottom bg-magenta1-light fade show text-center font-10"><i class="fa fa-sync fa-spin ml-3"></i>لطفا صبر کنید ...</div>
            </div>
        </transition>
        <transition enter-active-class="animated bounceInUp" leave-active-class="animated bounceOutDown">
            <div v-show="pageLoading==false" class="addBtn" id="addBtn" ref="addBtn" :style="{top:addButtonTop}">
                <router-link to="/VacationCreate" class="btn px-3 py-2  rounded-xl bg-green2-light font-900 text-white shadow-xl border-green2-dark">
                    <i class="fa fa-plus font-14"></i>
                </router-link>
            </div>
        </transition>
        <Help-Menu title="معرفی موبایل اپلیکیشن تسکینو" keyEn="TaskList"></Help-Menu>
    </div>
</template>

<script>
    import VueSimpleAlert from 'vue3-simple-alert';
	import HelpMenu from '../Components/HelpMenu.vue';
    export default {
		components: {
			"Help-Menu": HelpMenu
		},
        data() {
            return {
                pageLoading: false,
                vacationId: 0,
                list: []
            };
        },
        created() {
            this.GetVacationList();
        },
        computed: {
            VacationList() {
                return this.list;
            },
        },
        methods: {
            showAddButton() {
                this.pageLoaded = true;
            },
            showMenu(t) {
                this.vacationId = t.vacationId;
                document.getElementsByClassName("optionMenu")[0].click();
            },
            SendVacationMessage() {
                document.getElementsByClassName("menu-hider")[0].click();
                VueSimpleAlert.confirm(
                    "آیا مایل به ارسال پیام جهت برسی و تایید برای مدیر مرتبط هستید؟",
                    null,
                    "question",
                    { confirmButtonText: "تایید", cancelButtonText: "انصراف" }
                ).then(() => {
                    this.pageLoading = true;
                    this.$http
                        .get("Vacation/SendVacationMessage?id=" + this.vacationId)
                        .then((resData) => {
                            this.pageLoading = false;
                            var res = resData.data;
                            if (res.isSuccess) {
                                this.showSuccessMessage(res.message);
                            } else {
                                this.showErrorMessage(res.message);
                            }
     
                        });
                });
         
            },
            DeleteVacation() {
                document.getElementsByClassName("menu-hider")[0].click();
                VueSimpleAlert.confirm(
                    "آیا مایل به حذف این مورد هستید؟",
                    null,
                    "question",
                    { confirmButtonText: "تایید", cancelButtonText: "انصراف" }
                ).then(() => {
                    this.pageLoading = true;
                    this.$http
                        .get("Vacation/Delete?id=" + this.vacationId)
                        .then((data) => {
                            var res = data.data;
                            this.pageLoading = false;
                            if (res.isSuccess) {
                                this.GetVacationList();
                            } else {
                                this.showErrorMessage(res.message);
                            }
                        });
                });
            },
            GetVacationList() {
                this.pageLoading = true;
                this.$http
                    .get("Vacation/GetList")
                    .then((data) => {
                        var res = data.data;
                        this.list = res;
                        this.pageLoading = false;
                    });

            },
            openDetails(vacationId) {
				this.$router.push({ name: 'VacationEdit', params: { VacationId: vacationId } });
				document.getElementsByClassName('menu-hider')[0].click();
			},
        },
        mounted() {
            document
                .querySelectorAll(".menu-box-right")
                .forEach((a) => (a.style.display = "block"));
        },
    }
</script>